<template>
  <el-row :gutter="config.gutter" style="height：auto">
    <el-col :span="config.span">
      <el-card :shadow="config.shadow" :class="config.borderClass">
        <div class="panel-title">{{ $t(config.name) }}</div>
        <!-- 文件上传 -->
        <template v-if="config.type === 'file'||config.type === 'zip'">
        </template>
        <template v-else-if="config.type !== 'image'">
          <el-alert :closable="false" :title="$t('excel.tip')" type="success" />
        </template>
        <el-form size="mini" style="margin-top: 15px">
          <el-form-item
            :label="config.type != 'image' ? $t('upload.fileUpload') : ''"
          >
            <el-upload
              ref="upload"
              class="upload-demo"
              :action="config.action"
              :list-type="config.listType"
              :multiple="config.multiple"
              :file-list="config.fileList"
              :before-upload="beforeUpload"
              :on-success="onSuccess"
              :on-remove="onRemove"
              :on-error="onError"
              :accept="config.accept"
              :auto-upload="config.autoUpload"
              :headers="{Authorization: token}"
            >
              <template v-if="config.type == 'image'">
                <i slot="default" class="el-icon-plus" />
                <div slot="file" slot-scope="{ fileItem }">
                  <img
                    class="el-upload-list__item-thumbnail"
                    :src="fileItem.url"
                    alt
                  />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(fileItem)"
                    >
                      <i class="el-icon-zoom-in" />
                    </span>
                    <span
                      v-if="!disabled && fileItem.canRemove != false"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(fileItem)"
                    >
                      <i class="el-icon-delete" />
                    </span>
                  </span>
                </div>
                <div class="el-upload__tip" slot="tip">
                  {{ $t("image.tip") }}
                </div>
              </template>
              <template v-else-if="config.type == 'file'">
                <el-button
                  slot="trigger"
                  size="small"
                  :disabled="config.disabled"
                  type="primary"
                >{{ $t("upload.chioseFile") }}</el-button
                >
                <el-button
                  style="margin-left: 10px; margin-top: -10px"
                  size="small"
                  type="success"
                  @click="submitUpload"
                  :disabled="config.disabled"
                >{{ $t("upload.send") }}</el-button>
              </template>
              <template v-else-if="config.type == 'zip'">

                <el-button
                  slot="trigger"
                  size="small"
                  :disabled="config.disabled"
                  type="primary"
                >{{ $t("upload.chioseFile") }}</el-button
                >
              </template>
              <template v-else>
                <el-button
                  slot="trigger"
                  size="small"
                  :disabled="config.disabled"
                  type="primary"
                  >{{ $t("upload.chioseFile") }}</el-button
                >
                <el-button
                  style="margin-left: 10px; margin-top: -10px"
                  size="small"
                  type="success"
                  @click="submitUpload"
                  :disabled="config.disabled"
                  >{{ $t("upload.send") }}</el-button
                >
                <div
                  @click="handleClick(config.templateEvent)"
                  slot="tip"
                  class="el-upload__tip"
                >
                  <el-link
                    href="#"
                    type="success"
                    style="color: #06c; font-size: 13px"
                    >{{ $t("upload.downTemplate") }}</el-link
                  >
                </div>
              </template>
            </el-upload>
          </el-form-item>
        </el-form>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt />
        </el-dialog>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    refObj: {
      type: Object,
    },
    //配置参数
    config: {
      type: Object,
      default: () => {
        return {
          gutter: 10,
          span: 24,
          shadow: "never",
          borderClass: "no-border",
          type: "image",
          name: "upload.imgUpload",
          action: "",
          listType: "picture-card",
          multiple: true,
          accept: "",
          autoUpload: false,
          disabled: false,
        };
      },
    },
  },
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      submitObj: null,
      token: null
    };
  },
  computed: {},
  watch: {
    data: {
      handler: function (val) {
        // 将form实例返回到父级
        this.$emit("update:refObj", this.$refs.upload);
      },
      deep: true, // 深度监听
    },
  },
  mounted() {
    // 将form实例返回到父级
    this.$emit("update:refObj", this.$refs.upload);
    this.token = localStorage.getItem('token');
  },
  methods: {
    beforeUpload(file) {
      this.submitObj = this.submitObj || new FormData();
      this.submitObj.append("uploadFile", file);
      return true;
    },
    submitUpload() {
      this.$refs.upload.submit();
      let fileName = this.submitObj.get("uploadFileName");
      const submitObj = this.submitObj;
      this.handleClick(this.config.event, submitObj);
      this.submitObj = new FormData();
    },
    onSuccess(response, file, fileList) {
      if(response.code!=200){
        this.$message.error(response.msg);
        return;
      }
      this.config.fileList = fileList;
    },
    onRemove(file, fileList) {
      this.config.fileList = fileList;
    },
    onError(err, file, fileList){
      console.log(err);
    },
    // 绑定的相关事件
    handleEvent(evnet, data) {
      this.$emit("handleEvent", evnet, data);
    },
    // 派发按钮点击事件
    handleClick(event, data) {

      this.$emit("handleClick", event, data);
    },
  },
};
</script>
<style scoped>
.no-border {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/upload.vue